import { followActionType } from "./constains";
import { followUnfollow, fetchFollowers, fetchFollowing } from "./services";
import { errorParser } from "../../services/apiErrorParser";

/**
 * Follow Or Unfollow
 */
const followUnfollowStart = (data) => {
  return {
    type: followActionType.FOLLOW_START,
    payload: data,
  };
};

const followUnfollowSuccess = (data) => {
  return {
    type: followActionType.FOLLOW_SUCCESS,
    payload: data,
  };
};

const followUnfollowError = (error) => {
  return {
    type: followActionType.FOLLOW_ERROR,
    payload: error,
  };
};

export const _followUnfollow = (id) => (dispatch) => {
  return new Promise((resolve, reject) => {
    dispatch(followUnfollowStart(true));
    followUnfollow(id)
      .then(async (res) => {
        await dispatch(followUnfollowSuccess(res));
        resolve(res);
      })
      .catch(async (err) => {
        const parsedError = await errorParser.parseError(err);
        dispatch(followUnfollowError(parsedError));
        reject(err);
      });
  });
};

/**
 *  Follower List
 */
const fetchFollowerStart = (data) => {
  return {
    type: followActionType.FOLLOWERS_LOADING_START,
    payload: data,
  };
};

const fetchFollowerSuccess = (data) => {
  return {
    type: followActionType.FOLLOWERS_LOADING_SUCCESS,
    payload: data,
  };
};

const fetchFollowerError = (error) => {
  return {
    type: followActionType.FOLLOWERS_LOADING_ERROR,
    payload: error,
  };
};

export const _fetchFollowers = () => (dispatch) => {
  return new Promise((resolve, reject) => {
    dispatch(fetchFollowerStart(true));
    fetchFollowers()
      .then(async (res) => {
        await dispatch(fetchFollowerSuccess(res));
        resolve(res);
      })
      .catch(async (err) => {
        const parsedError = await errorParser.parseError(err);
        dispatch(fetchFollowerError(parsedError));
        reject(err);
      });
  });
};

/**
 * Following
 */
const fetchFollowingStart = (data) => {
  return {
    type: followActionType.FOLLOWING_LOADING_START,
    payload: data,
  };
};

const fetchFollowingSuccess = (data) => {
  return {
    type: followActionType.FOLLOWING_LOADING_SUCCESS,
    payload: data,
  };
};

const fetchFollowingError = (error) => {
  return {
    type: followActionType.FOLLOWING_LOADING_ERROR,
    payload: error,
  };
};

export const _fetchFollowing = () => (dispatch) => {
  return new Promise((resolve, reject) => {
    dispatch(fetchFollowingStart(true));
    fetchFollowing()
      .then(async (res) => {
        await dispatch(fetchFollowingSuccess(res));
        resolve(res);
      })
      .catch(async (err) => {
        const parsedError = await errorParser.parseError(err);
        dispatch(fetchFollowingError(parsedError));
        reject(err);
      });
  });
};